<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    :ok-disabled="disableSubmit||islock"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <sys-certificate-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit" :islock="islock" :systemlist="systemlist"></sys-certificate-form>
  </j-modal>
</template>

<script>

  import SysCertificateForm from './SysCertificateForm'
  export default {
    name: 'SysCertificateModal',
    components: {
      SysCertificateForm
    },
    props: {
      //表单禁用
      systemlist:{
        type:[String,Array],
        required:false,
      }
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false,
        islock:false,
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit({});
        })
      },
      edit (record) {
        if(!!record.lock){
          this.islock = record.lock
          if(record.lock){
            this.title = this.title+"-"+this.language['common.lock']
          }
        }else{
          this.islock = false;
        }
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>